import React, { Fragment } from 'react'
import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'
import { PageData } from 'api/Pagination/Types'
import { WelcomeTradingAccount } from 'api/Trading-Accounts/Types/WelcomeTradingAccount'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'
import { TableWithExport } from 'utils/table/withExport'

interface Props {
  data: PageData<WelcomeTradingAccount[]>
}

export const LeadDemoAccountsTable: React.FC<Props> = ({ data }) => {
  return (
    <Fragment>
      <TableWithExport data={data.items}>
        <Grid total={data.totalResults} data={data.items} resizable style={{ zIndex: 0 }}>
          <Column
            minResizableWidth={100}
            width={100}
            title='Name'
            field='name'
            cell={(cellProps: GridCellProps) => (
              <td style={{ color: 'var(--link)', textDecoration: 'underline', width: 'auto' }}>
                <Link
                  to={{
                    pathname: generatePath(links.recordsDemoAccounts.detailsUrl as string, {
                      id: cellProps.dataItem.id,
                      slug: 'details',
                    }),
                  }}
                >
                  {cellProps.dataItem.name}
                </Link>
              </td>
            )}
          />
          <Column
            minResizableWidth={160}
            width={160}
            title='Account Group'
            field='accountGroup.name'
            className='table-columns__content'
          />
          <Column
            minResizableWidth={160}
            width={160}
            title='Server'
            field='server.name'
            className='table-columns__content'
          />
          <Column
            minResizableWidth={100}
            width={100}
            title='Leverage'
            field='leverage.name'
            className='table-columns__content'
          />
          <Column
            minResizableWidth={80}
            width={80}
            title='Status'
            field='status.name'
            className='table-columns__content'
          />
          <Column
            minResizableWidth={80}
            width={80}
            title='Entity'
            field='tickmillCompany.name'
            className='table-columns__content'
            cell={(gridCellProps: GridCellProps) => {
              if (!gridCellProps.dataItem?.tickmillCompany?.id) {
                return <td />
              }

              return (
                <td>
                  <CompanyTag id={gridCellProps.dataItem.tickmillCompany.id}>
                    {gridCellProps.dataItem.tickmillCompany.name}
                  </CompanyTag>
                </td>
              )
            }}
          />
          <Column
            minResizableWidth={120}
            width={120}
            title='Created'
            cell={(gridCellProps) => (
              <td>{formatLocalDateUTC(gridCellProps.dataItem.created, true)}</td>
            )}
          />
          <Column
            minResizableWidth={120}
            width={120}
            title='Updated'
            cell={(gridCellProps) => (
              <td>{formatLocalDateUTC(gridCellProps.dataItem.updated, true)}</td>
            )}
          />
          <Column
            title='Form'
            children={[
              <Column
                minResizableWidth={120}
                width={120}
                title='Firstname'
                field='form.firstName'
                className='table-columns__content'
              />,
              <Column
                minResizableWidth={120}
                width={120}
                title='Lastname'
                field='form.lastName'
                className='table-columns__content'
              />,
              <Column
                minResizableWidth={120}
                width={120}
                title='Email'
                field='form.email'
                className='table-columns__content'
              />,
              <Column
                minResizableWidth={120}
                width={120}
                title='Phone'
                field='form.phoneNumber'
                className='table-columns__content'
              />,
              <Column
                minResizableWidth={150}
                width={150}
                title='Deposit Amount'
                field='form.depositAmount'
                className='table-columns__content'
              />,
            ]}
            className='table-columns__content'
          />
        </Grid>
      </TableWithExport>
    </Fragment>
  )
}
